import './types';

/**
 * @param {StatsLeadersState} draft - Draft state.
 * @param {StatsLeadersSortState} payload - Action payload.
 */
export const setBenchmarking = ( draft, payload ) => {
    draft.benchmarking = {
        ...draft.benchmarking,
        ...payload
    };
};